import { gql } from 'apollo-boost'

export const SYNC_USER = gql`
  mutation SyncUser {
    syncCurrentUser {
      message
    }
  }
`
